import Encoding from 'encoding-japanese'

export function readCsvFileAsUnicode(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (loadEvent) => {
      const u8Arr = new Uint8Array(loadEvent.target.result)
      resolve(Encoding.convert(u8Arr, {
        to: 'UNICODE',
        from: 'AUTO',
        type: 'string',
      }))
    }
    reader.onerror = (e) => reject(e)
    reader.readAsArrayBuffer(file)
  })
}

export function downloadResponseAsFile(response, fallbackFilename) {
  const blob = new Blob([response.data], { type: response.headers['content-type'] })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = parseFilenameFromContentDisposition(response.headers['content-disposition']) ?? fallbackFilename
  link.click()
  window.URL.revokeObjectURL(url)
}

export function parseFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null
  // RFC 5987 エンコード (filename*=UTF-8''...) を優先して解析
  const rfcMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i)
  if (rfcMatch) return decodeURIComponent(rfcMatch[1])
  // fallback: filename="..." または filename=...
  const match = contentDisposition.match(/filename="?([^";\n]+)"?/i)
  if (match) return match[1]
  return null
}
